import { Routes } from "@angular/router";
import { CohortsComponent } from "./pages/cohorts/cohorts.component";
import { CohortsListComponent } from "./pages/cohorts/cohorts-list/cohorts-list.component";
import { authGuard } from "./guards/auth.guard";

export const routes: Routes = [
	{
		path: "",
		redirectTo: "cohorts",
		pathMatch: "full",
	},
	{
		path: "login",
		loadComponent: () => import("./pages/login/login.component").then((m) => m.LoginComponent),
	},
	{
		path: "auth/email-link-signin",
		loadComponent: () =>
			import("./pages/auth/email-link-signin/email-link-signin.component").then(
				(m) => m.EmailLinkSigninComponent,
			),
	},
	{
		path: "auth/wrong-device",
		loadComponent: () =>
			import("./pages/auth/wrong-device/wrong-device.component").then(
				(m) => m.WrongDeviceComponent,
			),
	},
	{
		path: "cohorts",
		component: CohortsComponent,
		canActivate: [authGuard],
		children: [
			{
				path: "",
				component: CohortsListComponent,
			},
			{
				path: ":organizationCohortId/:memberId",
				loadComponent: () =>
					import("./pages/cohorts/cohort-detail/cohort-detail.component").then(
						(m) => m.CohortDetailComponent,
					),
			},
		],
	},
	{
		path: "profile",
		loadComponent: () =>
			import("./pages/profile/profile.component").then((m) => m.ProfileComponent),
		canActivate: [authGuard],
	},
	{
		path: "**",
		redirectTo: "cohorts",
	},
];
